import React from 'react';
import { ErrorModal } from './errorModal';
import styled from '@emotion/styled';
import EditorBtn from './UI/EditorBtn';
import * as Sentry from '@sentry/browser';

const Cont = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  display: flex;
`;

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

const Modal = styled.div`
  background: rgb(255, 255, 255);
  border-radius: 30px;
  padding: 32px;
  line-height: 1.6;
  z-index: 1001;
  max-width: 600px;
  box-shadow: 0 0 0 12px rgba(0, 0, 0, 0.2);

  & h1 {
    line-height: 2;
  }

  & div {
    line-height: 1.6;
  }

  & button {
    margin: 16px 0;
  }
`;

export class ErrorBoundary extends React.Component<
  any,
  { hasError: boolean; error: any; eventId: any }
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: undefined, eventId: undefined };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: error };
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    Sentry.withScope(scope => {
      scope.setExtras(info);
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Cont>
          <Backdrop />
          <Modal>
            <div>
              <h1>Oh no :(</h1>
              <p>Something has gone wrong. The error message provided is:</p>
              <p>
                <strong>"{this.state.error.toString()}".</strong>
              </p>
              <p>
                We have been alerted to this error, however if it is
                consistently occuring please fell free to notify us by clicking
                on the support button in the bottom right hand corner.
              </p>
            </div>
            <EditorBtn
              label="Reload"
              onClick={() => {
                window.location.reload();
              }}
            />
          </Modal>
        </Cont>
      );
    }

    return this.props.children;
  }
}
